import { CellContext } from '@tanstack/react-table';

import { Badge, BadgeType } from '@@/Badge';

import {
  EdgeConfigStateStrings,
  EdgeConfigStateType,
  EdgeConfiguration,
} from '../../types';

import { columnHelper } from './helper';

export const state = columnHelper.accessor('state', {
  header: 'Status',
  cell: Cell,
});

const stateToType: { [k in EdgeConfigStateType]: BadgeType } = {
  [EdgeConfigStateType.EdgeConfigIdleState]: 'success',
  [EdgeConfigStateType.EdgeConfigFailureState]: 'danger',
  [EdgeConfigStateType.EdgeConfigSavingState]: 'info',
  [EdgeConfigStateType.EdgeConfigDeletingState]: 'warn',
  [EdgeConfigStateType.EdgeConfigUpdatingState]: 'info',
};

function Cell({
  getValue,
}: CellContext<EdgeConfiguration, EdgeConfiguration['state']>) {
  const value = getValue();

  const state = EdgeConfigStateStrings[value];
  const type = stateToType[value];

  return <Badge type={type}>{state}</Badge>;
}
